import React, { useState } from 'react';
import styled from 'styled-components';
import { toast } from 'react-toastify';
import { etbDevManualLogin, etbDevRun } from '/imports/api/devtools';
import { toastOnError } from '/imports/ui/utils';
import { DevToolSection } from '/imports/ui/DevToolSection';
import { Input } from '/imports/ui/Input';
import { Button } from '/imports/ui/Button';

const Controls = styled.div`
  display: flex;
  gap: 0.5rem;
  align-items: center;
  flex-wrap: wrap;
`;

/** Dev tool for seeding the ETB trusted-device cookie and running the avoided-cost automation. */
export const DevToolEtb = () => {
  const [projectId, setProjectId] = useState('');
  const [loading, setLoading] = useState<'login' | 'run' | null>(null);
  const [result, setResult] = useState('');
  const manualLogin = toastOnError(async () => {
    setLoading('login');
    try {
      await etbDevManualLogin.call();
      toast.success('ETB manual login complete — trusted-device cookie saved.');
    }
    finally {
      setLoading(null);
    }
  });
  const run = toastOnError(async () => {
    if (!projectId.trim()) return toast.error('Enter a project _id first.');
    setLoading('run');
    setResult('');
    try {
      const res = await etbDevRun.call({ projectId: projectId.trim() });
      setResult(JSON.stringify(res, null, 2));
    }
    finally {
      setLoading(null);
    }
  });
  return (
    <DevToolSection
      title="ETB Avoided Cost"
      description="Run the Energy Toolbase automation. First time on a host: click <b>Manual Login</b> and complete MFA in the headed browser (5-minute window) to seed the trusted-device cookie. Then enter a project _id and click <b>Run</b> to model solar + ESS avoided cost end to end."
    >
      <Controls>
        <Button onClick={() => manualLogin()} disabled={!!loading}>{loading === 'login' ? 'Waiting for MFA…' : 'Manual Login'}</Button>
        <Input placeholder="project _id" value={projectId} onChange={(v) => setProjectId(v || '')} />
        <Button onClick={() => run()} disabled={!!loading}>{loading === 'run' ? 'Running…' : 'Run'}</Button>
      </Controls>
      {result && <pre>{result}</pre> || null}
    </DevToolSection>
  );
};
